module.exports = function (gsap) {
    /**
     * Menu scroll
     */
    const header = document.querySelector('.main-header');
    const sections = document.querySelectorAll('section.bg-black, .home-hero');

    window.addEventListener("scroll", (event) => {
        let scroll = this.scrollY;

        if (scroll > 1) {
            header.classList.add('is-scroll');
        } else {
            header.classList.remove('is-scroll');
            header.classList.remove('is-white');
        }

        sectionView();

    }, {
        passive: true
    });

    sectionView();

    function sectionView() {
        sections.forEach((item) => {
            if (
                item.getBoundingClientRect().top <= 55 &&
                !(item.getBoundingClientRect().top <= -(item.getBoundingClientRect().height - 55))
            ) {
                header.classList.add('is-white');
            } else if (
                item.getBoundingClientRect().top <= -(item.getBoundingClientRect().height - 55)
            ) {
                header.classList.remove('is-white');
            }
        })
    }

    /**
     * Links hide menu
     */
    const linksMenu = document.querySelectorAll('.main-menu a');

    let siteUrl = window.location.host;

    linksMenu.forEach(function (link) {

        link.addEventListener('click', (e) => {
            const href = link.getAttribute('href');

            // if (href.includes(siteUrl)) {
            //     e.preventDefault();

            //     const tlMainMenuDuration = tlMainMenu.duration();

            //     tlMainMenu.timeScale(2).reverse();
            //     btnMenu.classList.toggle('is-active');

            //     if (window.location.href !== href) {
            //         setTimeout(() => {
            //             window.location.href = href;
            //         }, tlMainMenuDuration / 2 * 1000)
            //     }
            // }
        });
    });

    /**
     * Main menu
     * @type {Element}
     */
    const btnMenu = document.querySelector('.main-aside__btn-menu'),
        popupBtn = document.querySelector('.main-aside__btn-letter');

    btnMenu.addEventListener("click", (item) => {
        btnMenu.classList.toggle('is-active');
        header.classList.toggle('is-menu-open');

        popupBtn.classList.toggle('is-hidden');

        if (btnMenu.classList.contains('is-active')) {
            tlMainMenu.timeScale(1).play();
        } else {
            tlMainMenu.timeScale(2).reverse();
        }
    });

    let tlMainMenu = gsap.timeline({
        paused: true
    })

    tlMainMenu
        .set('body', {
            overflow: 'hidden'
        })
        .to('.main-menu', {
            display: 'block',
            opacity: 1,
            duration: 0.55
        })
        .fromTo('.main-menu .heading-small', {
            xPercent: -100,
            opacity: 0
        }, {
            xPercent: 0,
            opacity: 1,
            duration: 0.5,
            ease: "back.out(1.7)"
        })
        .fromTo('.main-menu .main-menu__left .btn-single', {
            yPercent: 100,
            opacity: 0
        }, {
            yPercent: 0,
            opacity: 1,
            duration: 0.5,
            ease: "back.out(1.7)",
            stagger: 0.05
        })
        .fromTo('.main-menu .main-menu__right .btn-single', {
            yPercent: 100,
            opacity: 0
        }, {
            yPercent: 0,
            opacity: 1,
            duration: 0.5,
            ease: "back.out(1.7)",
            stagger: 0.05
        }, '-=0.6')
        .fromTo('.main-menu .social-media', {
            yPercent: 100,
            opacity: 0
        }, {
            yPercent: 0,
            opacity: 1,
            duration: 0.5,
            ease: "back.out(1.7)"
        }, '-=0.3')

    /**
     * Main menu mobile tabs
     * @type {NodeListOf<Element>}
     */
    const btns = document.querySelectorAll('.main-menu__btns__btn');

    btns.forEach((btn, index) => {
        btn.addEventListener('click', function () {
            btns.forEach((btn) => {
                btn.classList.remove('is-active');
            });
            if (!btn.classList.contains('is-active')) {
                btn.classList.add('is-active');
                if (index === 0) {
                    gsap.timeline()
                        .to('.main-menu__right', {
                            position: 'absolute',
                            top: 0,
                            display: 'none',
                            opacity: 0,
                            duration: 0.5
                        })
                        .to('.main-menu__left', {
                            position: 'relative',
                            display: 'block',
                            opacity: 1,
                            duration: 0.5
                        }, '-=0.3')
                } else {
                    gsap.timeline()
                        .to('.main-menu__left', {
                            position: 'absolute',
                            top: 0,
                            display: 'none',
                            opacity: 0,
                            duration: 0.5
                        })
                        .to('.main-menu__right', {
                            position: 'relative',
                            display: 'block',
                            opacity: 1,
                            duration: 0.5
                        }, '-=0.3')
                }
            } else {}
        })
    })

};